export default __webpack_public_path__ + "static/media/14.0ee27c1f.png";